interface response {
  code: number;
  message: string;
  data: {
    app_id: string;
    switch: boolean;
    verify_provider: string;
  };
}
interface captchaData {
  ret: number;
  ticket: string;
  CaptchaAppId: string;
  randstr: string;
  errorCode: number;
  errorMessage: string
}
let authCodeconf: response;
export function authCode () {
  let script: HTMLScriptElement;
  return new Promise<captchaData>((resolve, reject) => {
    if (authCodeconf) {
      authCodeCb(authCodeconf);
      return;
    }
    window.authCodeCb = authCodeCb;
    script = document.createElement('script');
    script.async = true;
    script.src = `${process.env.VUE_APP_SIGN_API}/v1/fraud/verify/config?callback=authCodeCb&channel=web&scene_type=activity`;
    script.onerror = reject;
    document.head.appendChild(script);
    function authCodeCb (res: response) {
      try {
        authCodeconf = res;
        if (res.code === 200) {
          const captcha = new TencentCaptcha(res.data.app_id, (data) => {
            if (data.ret === 0) {
              resolve(data);
            } else {
              reject(res);
            }
          });
          captcha.show();
        } else {
          reject(res);
        }
        script && script.parentNode && script.parentNode.removeChild(script);
      } catch (error) {
        script && script.parentNode && script.parentNode.removeChild(script);
        reject(error);
      }
    }
  });
}

